module.exports = __webpack_public_path__ + "static/img/8.32f2b13.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting711/images/8.png
// module id = Av0F
// module chunks = 4